import { Taccuino } from "../models/patient";
import axios from "./axios";

export async function fetchTaccuino(id: number) {
  const response = await axios.get(`/api/taccuino/${id}`);
  console.log(response);
  return response.data;
}

export async function getTaccuino(id: Number) {
  const response = await axios.get(`/api/getTaccuinos/${id}`);
  return response.data;
}

export async function updateTaccuino(params: Taccuino) {
  if (params.id_taccuino == 0) {
    const response = await axios.post(`/api/taccuino/`, params);
    return response.data;
  }
  const response = await axios.put(`/api/taccuino/${params.id_taccuino}`, params);
  return response.data;
}

export async function getTaccuinoImage(id: Number) {
  const response = await axios.get(`/api/taccuino/${id}/Images`);
  console.log("rst " )
  console.log( response)
  return response.data.data as Taccuino;
}

export async function deleteTaccuino(id: Number) {
  const response = await axios.delete(`/api/taccuino/${id}`);
  return response.data;
}

export async function storeEcgWithTakenImage(params:File){
  const response = await axios.post(`/api/taccuino/createCardiaTakeImage`,params);
  return response.data;
}

export async function getEcgImage(id: Number) {
  const response = await axios.get(`api/taccuino/ecg/getEcgPreview/${id}`);
  return response.data.data as File;
}